import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { ROUTES } from '@app/constants'
import { AnyAction, ThunkAction } from '@reduxjs/toolkit'
import { AppState } from '@app/store/reducer'

export const use404Redirect = (resetAction: () => ThunkAction<unknown, AppState, unknown, AnyAction>) => {
  const dispatch = useDispatch()
  const history = useHistory()

  const resetAndRedirect = () => {
    dispatch(resetAction())
    history.push(`/${ROUTES.page404}`)
  }

  return resetAndRedirect
}
